export default __webpack_public_path__ + "static/media/1988.eca74a7c.png";